export const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((v || "").trim());
export const isPhone = (v) => /^\+?\d{7,15}$/.test((v || "").replace(/[\s\-().]/g, ""));
export const isDigits = (v, n) => new RegExp(`^\\d{${n}}$`).test((v || "").replace(/[\s-]/g, ""));

const onlyDigits = (v) => (v || "").replace(/\D/g, "");

// NIP: 10 cyfr z poprawną sumą kontrolną
export const isNip = (v) => {
  const n = onlyDigits(v);
  if (n.length !== 10) return false;
  const w = [6, 5, 7, 2, 3, 4, 5, 6, 7];
  const s = w.reduce((a, x, i) => a + x * +n[i], 0) % 11;
  return s !== 10 && s === +n[9];
};

// REGON: 9 lub 14 cyfr z poprawną sumą kontrolną
export const isRegon = (v) => {
  const n = onlyDigits(v);
  const check = (str, w) => (w.reduce((a, x, i) => a + x * +str[i], 0) % 11) % 10;
  if (n.length === 9) return check(n, [8, 9, 2, 3, 4, 5, 6, 7]) === +n[8];
  if (n.length === 14) return isRegon(n.slice(0, 9)) && check(n, [2, 4, 8, 5, 0, 9, 7, 3, 6, 1, 2, 4, 8]) === +n[13];
  return false;
};

// PESEL: 11 cyfr z poprawną sumą kontrolną oraz prawidłową datą urodzenia
export const isPesel = (v) => {
  const n = onlyDigits(v);
  if (n.length !== 11) return false;
  const w = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
  const control = (10 - (w.reduce((a, x, i) => a + x * +n[i], 0) % 10)) % 10;
  if (control !== +n[10]) return false;
  const y = +n.slice(0, 2);
  let m = +n.slice(2, 4);
  const d = +n.slice(4, 6);
  let year;
  if (m >= 1 && m <= 12) year = 1900 + y;
  else if (m >= 21 && m <= 32) { year = 2000 + y; m -= 20; }
  else if (m >= 41 && m <= 52) { year = 2100 + y; m -= 40; }
  else if (m >= 61 && m <= 72) { year = 2200 + y; m -= 60; }
  else if (m >= 81 && m <= 92) { year = 1800 + y; m -= 80; }
  else return false;
  const dt = new Date(year, m - 1, d);
  return dt.getFullYear() === year && dt.getMonth() === m - 1 && dt.getDate() === d;
};

// Imię i nazwisko: min. 2 słowa, tylko litery (z polskimi znakami), spacje, myślniki, apostrofy, kropki
export const isFullName = (v) => {
  const s = (v || "").trim();
  if (!/^[\p{L}][\p{L}\s.'’-]*$/u.test(s)) return false;
  const words = s.split(/[\s-]+/).filter((w) => w.replace(/[.'’]/g, "").length >= 2);
  return words.length >= 2;
};

// Pełny adres: musi zawierać numer (cyfrę), litery oraz kod pocztowy w formacie 00-000
export const hasPostalCode = (v) => /\b\d{2}-\d{3}\b/.test(v || "");
export const isAddress = (v) => {
  const s = (v || "").trim();
  return s.length >= 6 && /\d/.test(s) && /\p{L}{2,}/u.test(s) && hasPostalCode(s);
};
export const isPostalCode = (v) => /^\d{2}-\d{3}$/.test((v || "").trim());

export const focusFirstError = (errors) => {
  const first = Object.keys(errors)[0];
  if (!first) return;
  const el = document.querySelector(`[data-field="${first}"]`);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "center" });
    if (typeof el.focus === "function") el.focus({ preventScroll: true });
  }
};

export function FieldError({ id, msg }) {
  if (!msg) return null;
  return (
    <p data-testid={`error-${id}`} role="alert" className="text-xs text-rose-500 mt-1.5 flex items-center gap-1">
      {msg}
    </p>
  );
}

export const errCls = (has) => (has ? "border-rose-500 focus-visible:ring-rose-500" : "");
